import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps'
import { useSettings } from '~/@mid_settings/settings'

type Props = { position: { lat: number; lng: number } }

export function GoogleMap({ position }: Props) {
  const {
    googleApi: { mapsApiKey },
  } = useSettings()

  if (!mapsApiKey) return null

  return (
    <div className="w-full h-full relative">
      <APIProvider apiKey={mapsApiKey}>
        <Map
          defaultCenter={position}
          defaultZoom={14}
          style={{ width: '100%', height: '100%', position: 'absolute' }}>
          <Marker position={position} />
        </Map>
      </APIProvider>
    </div>
  )
}
